const geoLoadBalancing ={
  'TITLE': 'Geo Load Balancing',
  'EDIT': 'Edit',
  'SAVE': 'Save',
  'CANCEL': 'Cancel',
  'NOTE': 'Note: Fresh leads will be distributed follow this ratio setup',
  'ALERT': 'The input value must not exceed'
}

export default geoLoadBalancing;